var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.inputLabel)?_c('label',{class:_vm.labelClass,attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.inputLabel)),_vm._t("default"),(_vm.isRequired)?_c('span',[_vm._v(" *")]):_vm._e()],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }